<script>
  import { mapGetters } from 'vuex';
  import Icon from '@/components/Icon';
  import Modal from '@/components/Modal';
  import WalletArrowGreen from '@/assets/wallet-arrow-green.svg';

  export default {
    components: {
      Icon,
      Modal,
      WalletArrowGreen,
    },

    data: () => ({
      step: 0,
    }),

    computed: {
      ...mapGetters('coins', [
        'coin',
      ]),

      title () {
        return `Receber ${this.coin.title}`;
      },
    },

    methods: {
      close () {
        this.$router.push('/carteira');
      },

      next () {
        if (this.step == 1) {
          return this.close();
        }

        this.step += 1;
      },
    },
  };
</script>

<template>
  <Modal
    :title="title"
    @close="close"
    class="wallet-deposit"
    >
    <Icon class="wallet-deposit__icon" :icon="coin.title" />

    <span class="wallet-deposit__arrow">
      <WalletArrowGreen
        />
    </span>

    <template v-if="step === 0">
      <p class="wallet-deposit__text wallet-deposit__text--limited">Envie o código que irá ser gerado para a pessoa que vair realizar a transferência.</p>
    </template>

    <template v-else-if="step === 1">
      <img class="wallet-deposit__qr-code" src="@/assets/qr-code.jpg">

      <p class="wallet-deposit__text">
        <span class="wallet-deposit__highlight">Endereço da carteira:</span>das234342uh32hu432
        <button class="wallet-deposit__action">
          Copiar
        </button>
      </p>
    </template>

    <button
      class="modal__action"
      @click.prevent="next"
      v-text="step === 0 ? 'Continuar' : 'Concluído'"
      >
    </button>
  </Modal>
</template>

<style lang="scss">
  .wallet-deposit {
    .modal__wrapper {
      display: flex;
      min-width: 550px;
      align-items: center;
      flex-direction: column;
    }

    &__arrow {
      width: 32px;
      height: 32px;
      display: flex;
      margin-top: -24px;
      margin-left: 52px;
      border-radius: 50%;
      align-items: center;
      justify-content: center;
      background-color: #14162f;

      svg {
        width: 14px;
      }
    }

    &__text {
      color: #b2b8c5;
      line-height: 1.5;
      text-align: center;
      margin: 16px 0 64px;

      &--limited {
        max-width: 230px;
      }
    }

    &__qr-code {
      margin: 32px 0;
    }

    &__action {
      color: #FFF;
      line-height: 1;
      font-size: 14px;
      margin-left: 16px;
      padding: 8px 16px;
      border-radius: 4px;
      border: 1px solid rgba(#FFF, .8);

      &:hover {
        border-color: #FFF;
        background-color: rgba(#FFF, 0.1);
      }
    }

    &__highlight {
      color: #FFF;
      line-height: 1.13;
      margin-right: 8px;
      letter-spacing: .32px;
    }

    &__icon {
      height: 70px;
    }
  }
</style>
